const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaVendedor: [],
    listaResultado: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'META_VENDEDOR_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'META_VENDEDOR_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'META_VENDEDOR_VENDEDOR_SELECT_LISTADO':
			return {
				...state,
				listaVendedor: action.payload.data
            };
            
        case 'META_VENDEDOR_RESULTADO_LISTADO':
        return { ...state, listaResultado: action.payload.data };

        default:
            return state;
    }
}
